import { Permission, User } from '@/interfaces/user.interface';
import { AccessControl } from 'accesscontrol';
import store from '@/store/store';

class PermissionsService {
  cache: any;
  accessControl: any;

  constructor() {
    this.cache = {
      permissions: [],
      updatedAt: null,
      duration: 60000 // milliseconds
    };
  }

  get permissions() {
    return this.cache.permissions;
  }

  get isExpired() {
    // @ts-ignore
    return new Date() - this.cache.updatedAt > this.cache.duration;
  }

  get ac() {
    return this.accessControl;
  }

  setPermissions(permissions: Permission[]) {
    this.cache.permissions = permissions;
    this.cache.updatedAt = new Date();
  }

  can(resource: string, action: string, attribute?: string, userUuid?: string): boolean {
    const user: User = store.getters['users/currentUser'];
    const notGranted = {
      granted: false,
      filter: () => {
      }
    };
    this.initAccessControl();
    if (!this.ac || !user) return false;
    if (userUuid && userUuid !== user.uuid) return false;
    if (userUuid && userUuid !== user.uuid) return false;
    let permissions;
    switch (action) {
      case 'read':
        permissions = this.ac.can(user.roleUuid).readAny(resource);
        break;
      case 'create':
        permissions = this.ac.can(user.roleUuid).createAny(resource);
        break;
      case 'update':
        permissions = this.ac.can(user.roleUuid).updateAny(resource);
        break;
      case 'delete':
        permissions = this.ac.can(user.roleUuid).deleteAny(resource);
        break;
      case 'read:own':
        permissions = this.ac.can(user.roleUuid).readOwn(resource);
        break;
      case 'create:own':
        permissions = this.ac.can(user.roleUuid).createOwn(resource);
        break;
      case 'update:own':
        permissions = this.ac.can(user.roleUuid).updateOwn(resource);
        break;
      case 'delete:own':
        permissions = this.ac.can(user.roleUuid).deleteOwn(resource);
        break;
      default:
        permissions = notGranted;
    }
    if (!attribute) attribute = '*';
    const filteredObject = permissions.filter({[attribute]: true});
    return permissions.granted && Object.keys(filteredObject).length > 0;
  }


  private initAccessControl() {
    if (this.permissions.length && !this.accessControl) {
      this.accessControl = new AccessControl(this.permissions);
    }
  }
}

export default new PermissionsService();
